import { tMaturityDate } from "../../interfaces/interfaces";

export enum eProActionTypes {
	SET_CURRENT_F_TOKEN = 'PRO/SET_CURRENT_F_TOKEN',
	SET_CURRENT_U_TOKEN = 'PRO/SET_CURRENT_U_TOKEN',
	SET_CURRENT_MATURITY_DATE = 'PRO/SET_CURRENT_MATURITY_DATE',
	CLEAR_STATE = 'PRO/CLEAR_STATE',
	SET_OPTIONS_PERIOD = 'PRO/SET_OPTIONS_PERIOD',
}

export type tProAction =
	iSetCurrentFTokenAction |
	iSetCurrentUTokenAction |
	iSetCurrentMaturityDateAction |
	iClearStateAction |
	iSetOptionsPeriodAction
;

interface iSetCurrentFTokenAction {
	type: eProActionTypes.SET_CURRENT_F_TOKEN,
	payload: string | null
}

interface iSetCurrentUTokenAction {
	type: eProActionTypes.SET_CURRENT_U_TOKEN,
	payload: string | null
}

interface iSetCurrentMaturityDateAction {
	type: eProActionTypes.SET_CURRENT_MATURITY_DATE,
	payload: tMaturityDate | null
}

interface iClearStateAction {
	type: eProActionTypes.CLEAR_STATE
}

interface iSetOptionsPeriodAction {
	type: eProActionTypes.SET_OPTIONS_PERIOD,
	payload: 'daily' | 'weekly'
}